(async()=>{
 let sessions;try{sessions=JSON.parse(sessionStorage.getItem('dp.preview.sessions.v1')||'{}');}catch{return;}
 const urls=new Map();
 for(const cell of document.querySelectorAll('[data-preview-design]')){
  const id=cell.dataset.previewDesign,session=sessions[id];
  if(!/^[a-f0-9-]{36}$/.test(id)||!session||session.expiresAt<Date.now()||!/^[a-f0-9]{64}$/.test(session.token))continue;
  try{
   if(!urls.has(id)){
    const response=await fetch(`https://previewapi-thgnkdml6q-ew.a.run.app/api/previews/${id}/image?kind=flat`,{headers:{'X-Preview-Token':session.token}});
    if(!response.ok||!/^image\/(png|jpeg)/.test(response.headers.get('content-type')||''))continue;
    urls.set(id,URL.createObjectURL(await response.blob()));
   }
   let img=cell.querySelector('img');
   if(!img){img=document.createElement('img');img.alt=document.documentElement.lang.startsWith('sv')?'Din kartmodell':'Your custom map';img.width=240;img.height=240;img.style.objectFit='contain';cell.replaceChildren(img);}
   img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=urls.get(id);
  }catch{/* Keep the catalogue image if preview access is unavailable. */}
 }
 addEventListener('pagehide',()=>{for(const url of urls.values())URL.revokeObjectURL(url);},{once:true});
})();
